<template lang="html">
  <footer class="footer">
    <div class="content has-text-centered">
      <div class="columns is-centered">
        <div class="column is-2">
          <router-link :to="{ path: '/about' }">About</router-link><br />
          <router-link :to="{ path: '/faq' }">Help & FAQ</router-link>
        </div>
        <div class="column is-2">
          <router-link :to="{ path: '/terms-of-service' }">Terms of Service</router-link
          ><br />
          <router-link :to="{ path: '/privacy-policy' }">Privacy Policy</router-link>
        </div>
        <div class="column is-2">
          <router-link :to="{ path: '/sponsors' }">Sponsors</router-link><br />
          <router-link :to="{ path: '/contact' }">Contact</router-link>
        </div>
      </div>

      <div class="columns is-vcentered is-centered">
        <div class="column is-1">
          <a href="https://www.facebook.com/costuto/"
            ><b-icon icon="facebook"></b-icon
          ></a>
        </div>
        <div class="column is-1">
          <a href="https://www.instagram.com/cos.tuto/"
            ><b-icon icon="instagram"></b-icon
          ></a>
        </div>
        <div class="column is-1">
          <a href="https://twitter.com/Tanukos/"><b-icon icon="twitter"></b-icon></a>
        </div>
        <div class="column is-1">
          <a href="https://www.youtube.com/channel/UCe6eo_Hj5q4Efs8vDdWXR5A/"
            ><b-icon icon="youtube"></b-icon
          ></a>
        </div>
      </div>

      <div class="columns is-vcentered">
        <div class="column is-1">
          <!-- To center the middle column -->
        </div>
        <div class="column">
          <strong>Costuto</strong> ©2020<br />
          All Rights Reserved
        </div>
        <div class="column is-1">Version 0.0.0</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
